export default __webpack_public_path__ + "static/media/img-12-thelxion.5355f331.jpg";